module.exports = __webpack_public_path__ + "static/media/calendar-icon-4.1f51898b.svg";